import script from "./TabView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabView.vue?vue&type=script&lang=ts&setup=true"

import "./TabView.vue?vue&type=style&index=0&id=279c2980&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279c2980"]])

export default __exports__